import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import moment, { months } from 'moment';
import { Subscription } from 'rxjs';
import { RiderOrder } from 'src/app/Common/RiderOrder/rider-order';
import { Constant } from 'src/app/Common/constant';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { RiderDto } from 'src/app/Model/Rider/rider-dto';
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { RiderService } from 'src/app/Service/Rider/rider.service';
import { RiderDetails } from 'src/app/Model/Rider/rider-details';
import { ShippingManagerService } from 'src/app/Service/Shipping/shipping-manager.service';
import { UntypedFormGroup } from '@angular/forms';
import { ShippingFareShippingWise } from 'src/app/Model/Shipping/shipping-fare-shipping-wise';
import { ShippingFareRiderDto } from 'src/app/Model/Shipping/shipping-fare-rider-dto';
import { copyFileSync } from 'fs';
import Highcharts from 'highcharts';
import HC_sunburst from 'highcharts/modules/sunburst';
import { Dashboard } from 'src/app/Model/Dashboard/dashboard';
import { DatePipe } from '@angular/common';
import { pushPullData, PushUserIdAndLocToAndroidApp } from 'src/myfunc';
import { getWindow } from 'ssr-window';
HC_sunburst(Highcharts);

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {
  showRiderName: string;
  riderEmail: string;
  Dashboard: Dashboard = new Dashboard();
  riderDto: RiderDto = new RiderDto();
  riderDetails: RiderDetails = new RiderDetails();
  
  currentDiv = 'Daily';
  currentData: any = null;
  last7DaysData: any[] = [];
  last30DaysData: any[] = [];
  totalQty: number = 0;
  totalAmount: number = 0;
  timeSpent: number = 0;
  totalQtyThisWeek: number = 0;
  totalAmountThisWeek: number = 0;
  totalQtyThisMonth: number = 0;
  totalAmountThisMonth: number = 0;

  DashboardStatus: boolean = false;
  shippingFareShippingWiseSlice: ShippingFareRiderDto[] = [];

  shippingFareShippingWise: ShippingFareRiderDto[] = [];

  myDataOrderTrendLine = [];
  widthOrderTrendLine: number = 0;
  heightOrderTrendLine: number = 0;
  columnNamesOrderTrendLine = [];
  riderOrderList: RiderOrder = new RiderOrder();

  myDataOrderTimeLine = [];
  widthOrderTimeLine: number = 0;
  heightOrderTimeLine: number = 0;
  columnNamesOrderQtyTrendLine = [];
  riderQtyList: RiderOrder = new RiderOrder();

  //Width change as per the screen Window/Android
  fullwidth: number = 0;

  fullHeight: number = 240;

  Highcharts: object;

  legendType: object = {
    legend: { position: 'none' },
    chartArea: { width: 150, height: 100 },
  };
  legendTypeFull: object = {
    legend: { position: 'none' },
    chartArea: {
      width: this.fullwidth,
      height: this.fullHeight,
      left: 30,
      top: 20,
      bottom: 40,
      right: 10,
    },
  };

  chartData = [
    ['Slot 1', 0],
    ['Slot 2', 0],
    ['Slot 3', 0],
    ['Slot 4', 0],
    ['Slot 5', 0],
    ['Slot 6', 0],
    ['Slot 7', 0],
    ['Slot 8', 0],
  ];
  filterData: string[] = [];
  toDate: string;
  fromDate: string;
  firstDayOfWeek: string;
  selectedValue: string;
  //subscription
  private onchangeStatusSubscription: Subscription;
  private getDeliveryFareDetailsSubscription: Subscription;
  dates: any = [];
  constructor(
    public persistenceService: LocalStorageService,
    private constant: Constant,
    private toastService: ToastrService,
    public createRiderService: RiderService,
    private apiUrl: APIFactoryEndPoints,
    public datePipe: DatePipe,
    private shippingManagerService: ShippingManagerService // public dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    console.log("User Data : In Dashboard");
    this.riderDetails.isVerified=false;
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.fromDate = moment().add(0, 'M').startOf('month').format('YYYY-MM-DD');
    this.firstDayOfWeek = this.datePipe.transform(
      this.getFirstDayOfWeek(new Date()),
      'yyyy-MM-dd'
    );
    this.filterData.push(this.toDate + ' (Today)');
    this.riderDetails = JSON.parse(
      this.persistenceService.get('rider_details')
    );
    console.log(this.riderDetails);
    this.showRiderName =
      this.riderDetails.firstName + ' ' + this.riderDetails.lastName;
    this.riderEmail = JSON.parse(this.persistenceService.get('google_email'));
  

    if (this.getOS() == "Android"){
      console.log("User Data : "+this.riderEmail);
        PushUserIdAndLocToAndroidApp(this.riderEmail, "0")
     }





    this.persistenceService.set(
      'isVerified',
      JSON.stringify(this.riderDetails.isVerified)
    );
    if (this.persistenceService.get('active_rider_status'))
      this.DashboardStatus = JSON.parse(
        this.persistenceService.get('active_rider_status')
      );

    this.fullwidth = window.innerWidth - 80;
    // this.gstTrendLineClick();
    // if (!this.riderDetails.isVerified) {
    //   this.toastService.showErrorToast('Your documents are not verified');
    // }
    this.getOrderLine();
    
      

  }

  ngOnDestroy() {
    if (this.onchangeStatusSubscription !== undefined)
      this.onchangeStatusSubscription.unsubscribe();

    if (this.getDeliveryFareDetailsSubscription !== undefined)
      this.getDeliveryFareDetailsSubscription.unsubscribe();
  }

  // onChange(toggle: MatSlideToggleChange) {
  //   this.onchangeStatusSubscription = this.createRiderService
  //     .updateStatus(
  //       this.apiUrl.updateActiveStatus,
  //       this.riderEmail,
  //       toggle.checked
  //     )
  //     .subscribe(
  //       (data: any) => {
  //         this.toastService.showSuccessToast(this.constant.statusUpdateToast);
  //         this.DashboardStatus = toggle.checked;
  //         this.persistenceService.set(
  //           'active_rider_status',
  //           this.DashboardStatus == true ? 'true' : 'false'
  //         );
  //       },
  //       (error: HttpErrorResponse) => {}
  //     );
  // }

  getOrderLine() {
    this.getOrderGraph();
    this.getDeliveryFareDetailsSubscription = this.shippingManagerService
      .getDeliveryFareDetails(this.apiUrl.deliveryFareDetails, this.riderEmail)
      .subscribe((data) => {
        console.log(data);
        this.shippingFareShippingWise = data;
        this.divClick('Daily', this.toDate, this.toDate);
      });
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  myTypeOrderTrendLine = 'ColumnChart';

  

  getOrderGraph() {
    this.myDataOrderTrendLine = [];
    const currentDate = new Date();
    const lastSevenDays = [];
    for (let i = 6; i >= 0; i--) {
      const date = new Date(currentDate);
      date.setDate(date.getDate() - i);
      lastSevenDays.push(date.toISOString().split('T')[0]);
    }

    lastSevenDays.forEach((day) => {
      const element = this.shippingFareShippingWise.find(
        (item) => item.date === day
      );

      if (element) {
        this.myDataOrderTrendLine.push([element.date, element.netPay]);
      } else {
        this.myDataOrderTrendLine.push([day, 0]);
      }
    });

    this.columnNamesOrderTrendLine = ['Date', 'Amount'];
    // this.widthOrderTrendLine = this.fullwidth / 2;
    this.widthOrderTrendLine = this.fullwidth + 55;

    this.heightOrderTrendLine = this.fullHeight - 30;
  }

  
  // notificationClicked() {
  //   const refNo = this.persistenceService.get('refNo');
  //   const message = this.persistenceService.get('message');
  //   const beep = this.persistenceService.get('beep');
  //   const readMessage = this.persistenceService.get('readMessage');
  //   if(refNo=='NA' || message=='NA' || beep=='NA' || readMessage=='NA' || refNo=='null' || message=='null' || beep=='null' || readMessage=='null' || refNo==null || message==null || beep==null || readMessage==null)
  //     this.toastService.showErrorToast("No notification to show")
  //   else
  //     pushPullData(refNo+"===="+message+"===="+beep+"===="+readMessage)
  // }
  getDates(startDate: Date, endDate: Date): Date[] {
    let currentDate: Date = startDate;
    this.dates = [];
    while (currentDate <= endDate) {
      this.dates.push(currentDate);
      currentDate = this.addDays(currentDate);
    }
    return this.dates;
  }
  private addDays(currentDate: Date): Date {
    let date = new Date(currentDate);
    date.setDate(date.getDate() + 1);
    return date;
  }

  getFirstDayOfWeek(date: Date): Date {
    const day = date.getDay();
    const firstDay = new Date(date);
    firstDay.setDate(date.getDate() - day);
    return firstDay;
  }
  calculateDaysDiff(dateSent) {
    let currentDate = new Date();
    dateSent = new Date(dateSent);

    return Math.floor(
      (Date.UTC(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate()
      ) -
        Date.UTC(
          dateSent.getFullYear(),
          dateSent.getMonth(),
          dateSent.getDate()
        )) /
        (1000 * 60 * 60 * 24)
    );
  }

  divClick(divC: string, fromDate: string, toDate: string) {
    this.totalQty = 0;
    this.totalAmount = 0;
    this.currentDiv = divC;
    this.timeSpent = 0;
    if (divC == 'Daily') {
      document.getElementById('totEarning').innerText =
        'Total earnings for the day';
      document.getElementById('performanceHead').innerText =
        'Date wise performance';
      document.getElementById('chartHead').innerText =
        'Time slot wise total earnings';
      this.showBarChart(divC, fromDate, toDate);
    }
    if (divC == 'Weekly') {
      document.getElementById('totEarning').innerText =
        'Total earnings in the week';
      document.getElementById('performanceHead').innerText =
        'Week wise performance';
      document.getElementById('chartHead').innerText =
        'Day wise total earnings';
      this.filterData = [];
      let frD = moment().add(-2, 'M').startOf('month').format('YYYY-MM-DD');
      let frDt;
      let toDt;
      let k = 0;
      for (let i = 0; i < this.calculateDaysDiff(frD); i += 7) {
        frDt = moment().add(-i, 'd').startOf('week').format('YYYY-MM-DD');
        if (frDt < frD) frDt = frD;
        toDt = moment().add(-i, 'd').endOf('week').format('YYYY-MM-DD');
        if (toDt >= this.toDate) toDt = this.toDate + ' (This Week)';
        else {
          toDt = toDt + ' (Before ' + ++k + ' Week)';
        }

        this.filterData.push(frDt + ' to ' + toDt);
      }
      this.showBarChart(
        divC,
        this.filterData[0].split(' to ')[0],
        this.filterData[0].split(' to ')[1].split('(')[0]
      );
      this.selectedValue = this.filterData[0];
    }
    if (divC == 'Monthly') {
      document.getElementById('totEarning').innerText =
        'Total earnings for the month';
      document.getElementById('performanceHead').innerText =
        'Month wise performance';
      document.getElementById('chartHead').innerText =
        'Date wise total earnings';
      this.filterData = [];
      let frDate = moment().add(-2, 'M').startOf('month').format('YYYY-MM-DD');
      let allDate = this.getDates(
        new Date(this.datePipe.transform(frDate, 'yyyy-MM-dd')),
        new Date(this.datePipe.transform(this.toDate, 'yyyy-MM-dd'))
      );
      let trD;
      for (let i = 0; i <= 2; i++) {
        let frD = moment().add(-i, 'M').startOf('month').format('YYYY-MM-DD');
        trD = moment().add(-i, 'M').endOf('month').format('YYYY-MM-DD');
        if (i == 0) trD = this.toDate + ' (This Month)';
        if (i == 1) trD = trD + ' (In '+ this.getMonthNameFromMonthNo(Number(trD.split("-")[1])) +')';
        if (i == 2) trD = trD + ' (In '+ this.getMonthNameFromMonthNo(Number(trD.split("-")[1])) +')';

        this.filterData.push(frD + ' to ' + trD);
      }
      this.showBarChart(
        divC,
        this.filterData[0].split(' to ')[0],
        this.filterData[0].split(' to ')[1].split('(')[0]
      );
      this.selectedValue = this.filterData[0];
    }
  }
  getMonthNameFromMonthNo(no:number)
  {
    if(no==1)
      return 'January'
    if(no==2)
      return 'February'
    if(no==3)
      return 'March'
    if(no==4)
      return 'April'
    if(no==5)
      return 'May'
    if(no==6)
      return 'June'
    if(no==7)
      return 'July'
    if(no==8)
      return 'August'
    if(no==9)
      return 'September'
    if(no==10)
      return 'October'
    if(no==11)
      return 'November'
    if(no==12)
      return 'December'
  }
  showBarChart(source: string, fromDate: string, toDate: string) {
    if (source == 'Daily') {
      this.totalQty = 0;
      this.totalAmount = 0;
      this.timeSpent = 0;
      this.filterData = [];
      this.filterData.push(this.toDate + ' (Today)');
      let frDate = moment().add(-2, 'M').startOf('month').format('YYYY-MM-DD');
      let allDates = this.getDates(
        new Date(this.datePipe.transform(frDate, 'yyyy-MM-dd')),
        new Date(this.datePipe.transform(this.toDate, 'yyyy-MM-dd'))
      );
      let k = 0;
      for (let i = allDates.length - 2; i >= 0; i--) {
        this.filterData.push(
          this.datePipe.transform(allDates[i].toString(), 'yyyy-MM-dd') +
            ' (Before ' +
            ++k +
            ' day)'
        );
      }

      document.getElementById('daily').style.setProperty('color', 'white');
      document.getElementById('weekly').style.setProperty('color', 'black');
      document.getElementById('monthly').style.setProperty('color', 'black');
      this.chartData = [];
      this.chartData.push(['slot1', 0]);
      this.chartData.push(['slot2', 0]);
      this.chartData.push(['slot3', 0]);
      this.chartData.push(['slot4', 0]);
      this.chartData.push(['slot5', 0]);
      this.chartData.push(['slot6', 0]);
      this.chartData.push(['slot7', 0]);
      this.chartData.push(['slot8', 0]);

      this.chartData.forEach((e) => {
        let foundSlot: boolean = false;
        let netPay = 0;
        let slicedData = this.shippingFareShippingWise.filter(
          (e) => e.date >= fromDate && e.date <= toDate
        );
        console.log('Date Sliced=' + slicedData);
        slicedData.forEach((f) => {
          if (e[0] == f.time) {
            foundSlot = true;
            netPay += f.netPay;
            this.totalQty++;
            this.totalAmount += f.netPay;
            this.timeSpent += Number(f.timeSpent);
          }
        });
        if (foundSlot) e[1] = netPay;
      });
      this.chartData.forEach((e) => {
        if (e[0] == 'slot1') e[0] = '00:00 - 02:59';
        if (e[0] == 'slot2') e[0] = '03:00 - 05:59';
        if (e[0] == 'slot3') e[0] = '06:00 - 08:59';
        if (e[0] == 'slot4') e[0] = '09:00 - 11:59';
        if (e[0] == 'slot5') e[0] = '12:00 - 14:59';
        if (e[0] == 'slot6') e[0] = '15:00 - 17:59';
        if (e[0] == 'slot7') e[0] = '18:00 - 20:59';
        if (e[0] == 'slot8') e[0] = '21:00 - 23:59';
      });
      this.selectedValue = this.filterData[0];
    }
    if (source == 'Weekly') {
      document.getElementById('daily').style.setProperty('color', 'black');
      document.getElementById('weekly').style.setProperty('color', 'white');
      document.getElementById('monthly').style.setProperty('color', 'black');
      this.chartData = [];
      this.totalQty = 0;
      this.totalAmount = 0;
      this.timeSpent = 0;
      let allDates = this.getDates(
        new Date(this.datePipe.transform(fromDate, 'yyyy-MM-dd')),
        new Date(this.datePipe.transform(toDate, 'yyyy-MM-dd'))
      );
      allDates.forEach((kk) => {
        let amtOnTheDay = 0;
        let slicedData = this.shippingFareShippingWise.filter(
          (e) => e.date === this.datePipe.transform(kk, 'yyyy-MM-dd')
        );
        slicedData.forEach((f) => {
          amtOnTheDay += f.netPay;
          this.totalQty++;
          this.totalAmount += f.netPay;
          this.timeSpent += Number(f.timeSpent);
        });
        this.chartData.push([
          this.datePipe.transform(kk, 'yyyy-MM-dd'),
          amtOnTheDay,
        ]);
      });
    }
    if (source == 'Monthly') {
      document.getElementById('daily').style.setProperty('color', 'black');
      document.getElementById('weekly').style.setProperty('color', 'black');
      document.getElementById('monthly').style.setProperty('color', 'white');

      let allDates = this.getDates(
        new Date(this.datePipe.transform(fromDate, 'yyyy-MM-dd')),
        new Date(this.datePipe.transform(toDate, 'yyyy-MM-dd'))
      );
      this.chartData = [];
      this.totalQty = 0;
      this.totalAmount = 0;
      this.timeSpent = 0;
      allDates.forEach((kk) => {
        let amtOnTheDay = 0;
        let slicedData = this.shippingFareShippingWise.filter(
          (e) => e.date == this.datePipe.transform(kk, 'yyyy-MM-dd')
        );
        console.log('Sliced Data====' + slicedData);
        slicedData.forEach((f) => {
          amtOnTheDay += f.netPay;
          this.totalQty++;
          this.totalAmount += f.netPay;
          this.timeSpent += Number(f.timeSpent);
        });
        this.chartData.push([this.datePipe.transform(kk, 'dd'), amtOnTheDay]);
      });
    }
  }

  onFilterSelect(data: any) {
    if (this.currentDiv == 'Daily') {
      this.showBarChart(
        this.currentDiv,
        data.split(' ')[0],
        data.split(' ')[0]
      );
    }
    if (this.currentDiv == 'Weekly' || this.currentDiv == 'Monthly') {
      this.showBarChart(
        this.currentDiv,
        data.split(' to ')[0],
        data.split(' to ')[1].split('(')[0]
      );
    }
  }
  getOS() {
    var uA = getWindow().navigator.userAgent || getWindow().navigator.vendor;
    if (
      /iPad|iPhone|iPod/.test(uA) ||
      (uA.includes('Mac') && 'ontouchend' in document)
    )
      return 'iOS';
    // if (this.getBrowserName().includes("Safari"))
    //   return "Android"
    // else
    //   return "Windows"
    var i,
      os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], 'i').test(uA))
        if (os[i] != 'Android') return 'Web';
        else return os[i];
  }
}
